import NoteItem from './NoteItem'
import classes from './NoteList.module.css';

function NoteList(props) {
    return (
        <ul className={classes.list}>
            {props.notes.map(note => <NoteItem 
            key={note.id}
            id={note.id}
            image={note.image}
            title={note.title}
            dt={note.dt}
            detail={note.detail}
            />)}
            
        </ul>
    );
}

export default NoteList;
